import { render, staticRenderFns } from "./csbdRender.vue?vue&type=template&id=7cdc7090&scoped=true&"
import script from "./csbdRender.vue?vue&type=script&lang=js&"
export * from "./csbdRender.vue?vue&type=script&lang=js&"
import style0 from "./csbdRender.vue?vue&type=style&index=0&id=7cdc7090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc7090",
  null
  
)

export default component.exports